import {
  PDP_DEATAIL,
  PDP_VIEW,
  PDP,
  NAVIGATION,
  CROSS_SELL,
  ADD_INSTALL,
  PURCHASE_DESIGN,
  STORE_NEAR,
  FIND_PRO,
  ADD_TO_CART,
  BASED_ON_LOCATION,
  PRODUCT_DECS,
  PRODUCT_TYPE,
  PRODUCT_INSATLL,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/constant"
import { getPureText } from "@/utils/helper"

export const addAnalyticsForViewNowClick = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:view now`,
    eventName: `${PDP}:${PDP_DEATAIL}:view now`,
    eventType: NAVIGATION,
    internalLinkName: "view now",
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${PDP_VIEW}`,
    internalLinkZoneName: `${PDP}:${PDP_DEATAIL}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForCloseClick = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}:close`,
    eventName: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}:close`,
    eventType: NAVIGATION,
    internalLinkName: "close",
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:close`,
    internalLinkZoneName: `${PDP}:${PDP_DEATAIL}:modal:${PDP_VIEW}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForChangeZipCode = (
  titleName = "",
  productInfo = {},
  zipval = 0
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${zipval}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${BASED_ON_LOCATION}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForUpdate = (
  titleName = "",
  productInfo = {},
  zipval = 0,
  showcard = true
) => {
  const title = titleName.toLowerCase()
  const eventStatusItem = showcard ? "success" : "failure"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title} zip code`,
    eventName: `${PDP}:${CROSS_SELL}:${title} zip code`,
    eventMsg: "n/a",
    eventStatus: `${eventStatusItem}`,
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${zipval}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${BASED_ON_LOCATION}`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForBuymore = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${ADD_INSTALL}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}`,
    internalLinkURL: url ? url : "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForAddService = (
  titleName = "",
  productitem = {},
  serviceName = "",
  servicePrice = 0,
  productServices = ""
) => {
  const title = titleName.toLowerCase()
  const service = getPureText(serviceName).toLowerCase()
  const { productName = "", quantity = 1, productBrand = "" } = productitem
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}:${ADD_TO_CART}`,
    eventName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}:${ADD_TO_CART}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${service}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${ADD_INSTALL}`,
    internalLinkURL: "n/a",
  }
  const productInfo = {
    defaultImageName: "n/a",
    description: PRODUCT_DECS,
    frequency: "n/a",
    globalPromotionPrice: servicePrice,
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    numberOfReviews: "n/a",
    pdpType: PRODUCT_TYPE,
    priceState: "regular price",
    productBasePrice: servicePrice,
    productBrand: productBrand,
    productCategory: PRODUCT_INSATLL,
    productCollectionsName: PRODUCT_INSATLL,
    productColor: "n/a",
    productCouponCode: "n/a",
    productCoupondiscount: "n/a",
    productFindingMethod: "n/a",
    productID: productServices,
    productName: productName,
    productPartnerBuyNow: "n/a",
    productRoom: PRODUCT_INSATLL,
    productSalePrice: servicePrice,
    productSaleable: "true",
    productStatus: "in stock",
    productSuperSku: "false",
    productTileName: "installation services",
    quantity: quantity,
    ratings: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForBathroomDesign = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${PURCHASE_DESIGN}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${PURCHASE_DESIGN}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForStoreNearYou = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${STORE_NEAR}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${STORE_NEAR}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const addAnalyticsForGetProfessionalClick = (
  titleName = "",
  url,
  productInfo = {}
) => {
  const title = titleName.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PDP}:${CROSS_SELL}:${title}`,
    eventName: `${PDP}:${CROSS_SELL}:${title}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: title,
    internalLinkPosition: PDP,
    internalLinkType: `${PDP}:${FIND_PRO}`,
    internalLinkZoneName: `${PDP}:${CROSS_SELL}:${FIND_PRO}`,
    internalLinkURL: url,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}
